/* tslint:disable */
/* eslint-disable */
/**
 * Notifications API
 * An API to create and read notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: DevTeamProduct@digitalrealty.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime.js';
/**
 * Result of a bulk notifications patch operation
 * @export
 * @interface NotificationBulkPatchResult
 */
export interface NotificationBulkPatchResult {
    /**
     * Number of notifications updated
     * @type {number}
     * @memberof NotificationBulkPatchResult
     */
    updatedCount?: number;
}

/**
 * Check if a given object implements the NotificationBulkPatchResult interface.
 */
export function instanceOfNotificationBulkPatchResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NotificationBulkPatchResultFromJSON(json: any): NotificationBulkPatchResult {
    return NotificationBulkPatchResultFromJSONTyped(json, false);
}

export function NotificationBulkPatchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationBulkPatchResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updatedCount': !exists(json, 'updated_count') ? undefined : json['updated_count'],
    };
}

export function NotificationBulkPatchResultToJSON(value?: NotificationBulkPatchResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updated_count': value.updatedCount,
    };
}

